import type { MaterialAbsorvente } from './tipos'

/** Materiais com que se absorve um derramamento, na ordem em que a interface os oferece. */
export const MATERIAIS_PADRAO_DERRAMAMENTO: readonly MaterialAbsorvente[] = ['serragem', 'areia', 'absorvente_industrial']

export const ROTULOS_MATERIAL: Readonly<Record<MaterialAbsorvente, string>> = {
  serragem: 'Serragem',
  areia: 'Areia',
  absorvente_industrial: 'Absorvente industrial',
}

/** O que se vê de um risco na cena 3D (vidro varrido, derramamento coberto, fogo extinto...). */
export interface AparenciaRisco {
  readonly fragmentosRemovidos?: boolean
  readonly coberto?: boolean
  readonly absorvente?: MaterialAbsorvente
  readonly vazando?: boolean
  readonly areaIsolada?: boolean
  readonly energizado?: boolean
  readonly extinto?: boolean
}
